import { Box, Card, CardContent, Skeleton, Tooltip, Typography } from "@mui/material";
import { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { LoginResponse } from "subModule/src/services/userProfile/interface";
import { EnqueueSnackbar } from "notistack";
import AlertMessages from "common/Alert/AlertMessages";
import { GetFinancesResponse } from "subModule/src/services/bankaccount/interface";
import { useGetFinanceProfitLosService } from "subModule/src/services/bankaccount/useBankAccount";
interface AccountsProfitLossProps {
    user: LoginResponse | undefined;
    themes: any;
    enqueueSnackbar: EnqueueSnackbar;
    setPLLoading: any;
    profitLossFilters: boolean;
    startDate: any;
    endDate: any;
    setProfitLossFilters: any;
}
export default function AccountsProfitLoss(props: AccountsProfitLossProps) {
    const { t } = useTranslation();
    const firstRender = useRef(true);
    const [data, setData] = useState<any>(null);
    const [loader, setLoader] = useState<boolean>(true);
    const { refetch: apiRefetch } = useGetFinanceProfitLosService({ start: props?.startDate, end: props?.endDate });
    useEffect(() => {
        if (firstRender.current) {
            firstRender.current = false;
            setTimeout(() => fetchData(), 50);
        }
    }, []);
    useEffect(() => {
        if(props.profitLossFilters) setTimeout(() => fetchData(), 100);
    }, [props.profitLossFilters]);
    const fetchData = async () => {
        props.setPLLoading(true);
        setLoader(true);
        await apiRefetch().then((res: GetFinancesResponse | unknown | any) => {
            if (res?.data?.success) {
                setData(res?.data?.data || {});
            } else {
                props.enqueueSnackbar(<AlertMessages text={res?.data?.message || "Something went wrong"} />, { variant: "error" });
            }
        }).catch((err: any) => {
            console.error("===", err);
        }).finally(() => {
            props.setPLLoading(false);
            props.setProfitLossFilters(false);
            setLoader(false);
        });
    };
    return (
        <Card sx={{ height: '150px', boxShadow: 'none', borderRadius: '8px', '& .MuiCardContent-root': { padding: '16px 0 !important' } }}>
            <CardContent>
                {loader ? <Skeleton animation="pulse" sx={{ backgroundColor: props?.themes?.secondary, margin: '0 16px' }} /> : <Box className={`flex gap-1 items-center justify-between px-[16px]`}>
                    <Typography variant="h1" gutterBottom className="font-Saira text-[15px] font-extrabold">{data?.["Profit/Loss"] < 0 ? t('loss') : t('Profit')}</Typography>
                    <Tooltip followCursor title={data?.["Profit/Loss"]?.toLocaleString() || '-'}>
                        <Typography variant="h2" gutterBottom className="font-Saira text-[13px] font-semibold py-[5px] px-[15px] rounded-[99px]"
                            style={{
                                background: data?.["Profit/Loss"] > 0 ? `#4CAF5020` : data?.["Profit/Loss"] < 0 ? `#D32F2F10` : `#00000010`,
                                color: data?.["Profit/Loss"] > 0 ? `#4CAF50` : data?.["Profit/Loss"] < 0 ? `#D32F2F` : `#000000`
                            }}
                        >
                            {data?.["Profit/Loss"]?.toLocaleString() || '-'}{' '}
                            <span className="uppercase">{props?.user?.business?.currency || ''}</span>
                        </Typography>
                    </Tooltip>
                </Box>}
            </CardContent>
        </Card>
    );
}